<template>
<b-row>
  <b-col>
    <b-row>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.form.number') }}:</label>
        <input v-model.lazy="filters.number" v-debounce="delay" class="form-control" type="text" :placeholder="$t('views.exsbinvoices.form.number')"/>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.form.buyer') }}:</label>
        <input v-model.lazy="filters.buyerFilter" v-debounce="delay" class="form-control" type="text" :placeholder="$t('views.exsbinvoices.form.buyer')"/>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <div class="form-group">
          <label class="form-control-label">{{ $t('views.exsbinvoices.form.invoiceType') }}:</label>
          <model-select :placeholder="$t('views.exsbinvoices.form.invoiceType')" :options="invoiceTypes" v-model="filters.invoiceType"></model-select>
        </div>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <div class="form-group">
          <label class="form-control-label">{{ $t('views.exsbinvoices.form.invoiceStatus') }}:</label>
          <model-select :placeholder="$t('views.exsbinvoices.form.invoiceStatus')" :options="invoiceStatusOptions" v-model="filters.invoiceStatus"></model-select>
        </div>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.list.invoicesFilter.dateType') }}:</label>
        <model-select @input="onDateTypeSelect($event)" v-model="dateType" :options="dateTypeOptions" name="dateType" :placeholder="$t('views.exsbinvoices.list.invoicesFilter.dateType')">
        </model-select>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{$t('views.agreements.form.paymentPeriod') }}:</label><br>
        <DatePicker
          style="width: 100%"
          @input="onPeriodSelect($event)"
          type="month"
          lang="pl"
          v-model="periodDate"
          name="periodDate"
          :placeholder="$t('views.agreements.form.paymentPeriod')"
          valueType="YYYY-MM"
        ></DatePicker>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12" v-if="dateType === 1">
        <label>{{$t('views.exsbinvoices.form.issueDate') + ' '
        + $t('global.smFrom')}}:</label>
        <VueCtkDateTimePicker no-header
                              :label="$t('views.exsbinvoices.form.issueDate') + ' '
                                  + $t('global.smFrom')"
                              v-model.lazy="filters['issueDate[after]']"
                              v-debounce="delay"
                              format="YYYY-MM-DD"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
        >
        </VueCtkDateTimePicker>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12" v-if="dateType === 1">
        <label>{{$t('views.exsbinvoices.form.issueDate')  + ' '
        + $t('global.smTo')}}:</label>
        <VueCtkDateTimePicker no-header
                              :label="$t('views.exsbinvoices.form.issueDate')  + ' '
                                  + $t('global.smTo')"
                              v-model.lazy="filters['issueDate[before]']"
                              v-debounce="delay"
                              format="YYYY-MM-DD"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
        >
        </VueCtkDateTimePicker>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12" v-if="dateType === 2">
        <label>{{$t('views.exsbinvoices.form.sellDate') + ' '
        + $t('global.smFrom')}}:</label>
        <VueCtkDateTimePicker no-header
                              :label="$t('views.exsbinvoices.form.sellDate') + ' '
                                  + $t('global.smFrom')"
                              v-model.lazy="filters['sellDate[after]']"
                              v-debounce="delay"
                              format="YYYY-MM-DD"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
        >
        </VueCtkDateTimePicker>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12" v-if="dateType === 2">
        <label>{{$t('views.exsbinvoices.form.sellDate')  + ' '
        + $t('global.smTo')}}:</label>
        <VueCtkDateTimePicker no-header
                              :label="$t('views.exsbinvoices.form.sellDate')  + ' '
                                  + $t('global.smTo')"
                              v-model.lazy="filters['sellDate[before]']"
                              v-debounce="delay"
                              format="YYYY-MM-DD"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
        >
        </VueCtkDateTimePicker>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.list.invoicesFilter.correction') }}:</label>
        <model-select v-model="filters.correctionFilter" :options="correctionOptions" name="sort" :placeholder="$t('views.exsbinvoices.list.invoicesFilter.correction')">
        </model-select>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.list.invoicesFilter.sort') }}:</label>
        <model-select v-model="filters.order" :options="sortOptions" name="sort" :placeholder="$t('views.exsbinvoices.list.invoicesFilter.sort')">
        </model-select>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.appconfiguration.invoiceConfiguration.invoiceComment') }}:</label>
        <input v-model.lazy="filters.comments" v-debounce="delay" class="form-control" type="text" :placeholder="$t('views.appconfiguration.invoiceConfiguration.invoiceComment')"/>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.form.invoicePositionHeaders.item') }}:</label>
        <input v-model.lazy="filters.invoicePositionsFilter" v-debounce="delay" class="form-control" type="text" :placeholder="$t('views.exsbinvoices.form.invoicePositionHeaders.item')"/>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.list.hasDiscountFilter') }}:</label>
        <b-form-group>
          <b-form-radio-group
            v-model="filters.hasDiscountFilter"
            :options="radioOptionsHasDiscount"
            buttons
            button-variant="outline-primary"
            name="radios-btn-default"
          ></b-form-radio-group>
        </b-form-group>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.list.buyerTags') }}:</label>
        <multi-select @select="onSelectBuyerTag" :options="buyerTagOptions" :selected-options="buyerTagsFilter"></multi-select>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.list.agreementTags') }}:</label>
        <multi-select @select="onSelectAgreementTag" :options="agreementTagOptions" :selected-options="agreementTagsFilter"></multi-select>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12" v-if="$store.getters['configuration/ksefEnabled']">
        <label>{{ $t('global.ksefStatus') }}:</label>
        <model-select v-model="filters.ksefStatusFilter" :options="ksefStatusOptions" name="ksefStatusFilter" :placeholder="$t('global.ksefStatus')">
        </model-select>
      </div>
      <div class="form-group col-lg-3 col-md-4 col-sm-12">
        <label>{{ $t('views.exsbinvoices.list.sent') }}:</label>
        <b-form-group>
          <b-form-radio-group
            v-model="filters.sent"
            :options="radioOptionsSent"
            buttons
            button-variant="outline-primary"
            name="radios-btn-default"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </b-row>
  </b-col>
</b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect, MultiSelect } from 'vue-search-select'
import addParamsToQuery from '@/utils/addParamsToQuery'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import debounce from 'v-debounce'
import getId from '@/utils/getIdFromLink'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pl'
import ApiService from '@/utils/ApiService'

export default {
  name: 'InvoiceFiltering',
  components: {
    ModelSelect,
    MultiSelect,
    VueCtkDateTimePicker,
    DatePicker
  },
  props: ['filters', 'filterReference', 'currentPageProp', 'periodDateProp', 'dateTypeProp'],
  data () {
    return {
      delay: 500,
      correctionOptions: [
        { value: null, text: this.$t('views.exsbinvoices.list.invoicesFilter.correctionFilter.allDocuments') },
        { value: 1, text: this.$t('views.exsbinvoices.list.invoicesFilter.correctionFilter.onlyInvoices') },
        { value: 2, text: this.$t('views.exsbinvoices.list.invoicesFilter.correctionFilter.onlyCorrections') },
        { value: 3, text: this.$t('views.exsbinvoices.list.invoicesFilter.correctionFilter.onlyInvoicesWithCorrections') },
        { value: 4, text: this.$t('views.exsbinvoices.list.invoicesFilter.correctionFilter.onlyInvoicesWithoutCorrections') }
      ],
      ksefStatusOptions: [
        { value: 0, text: this.$t('global.allPosition') },
        { value: 1, text: this.$t('global.sentToStatus') },
        { value: 2, text: this.$t('global.notSentToStatus') },
        { value: 3, text: this.$t('global.errorSentToStatus') }
      ],
      sortOptions: [
        { value: 1, text: this.$t('views.exsbinvoices.list.invoicesFilter.sortWay.createOrder') },
        { value: 0, text: this.$t('views.exsbinvoices.list.invoicesFilter.sortWay.sortByNumber') },
        { value: 2, text: this.$t('views.exsbinvoices.list.invoicesFilter.sortWay.sortByIssueDate') },
        { value: 3, text: this.$t('views.exsbinvoices.list.invoicesFilter.sortWay.sortBySellDate') }
      ],
      dateTypeOptions: [
        { value: 1, text: this.$t('views.exsbinvoices.form.issueDate') },
        { value: 2, text: this.$t('views.exsbinvoices.form.sellDate') }
      ],
      radioOptionsSent: [
        { value: '', text: this.$t('global.all') },
        { value: 0, text: this.$t('buttons.no') },
        { value: 1, text: this.$t('buttons.yes') }
      ],
      radioOptionsHasDiscount: [
        { value: '', text: this.$t('global.all') },
        { value: 0, text: this.$t('buttons.no') },
        { value: 1, text: this.$t('buttons.yes') }
      ],
      periodDate: this.periodDateProp,
      dateType: this.dateTypeProp,
      currentPage: this.dateTypeProp,
      buyerTagsFilter: [],
      buyerTagOptions: [],
      agreementTagsFilter: [],
      agreementTagOptions: []
    }
  },
  computed: {
    documentTypeOptions () {
      return this.documentTypes.map(entry => {
        return {
          text: this.$t(entry.text),
          value: entry.value
        }
      })
    },
    invoiceStatusOptions () {
      return this.invoiceStatuses.map(entry => {
        return {
          text: entry.name,
          value: getId(entry['@id'])
        }
      })
    },
    paymentWayOptions () {
      return this.paymentWays.map(entry => {
        return {
          text: entry.name,
          value: getId(entry['@id'])
        }
      })
    },
    ...mapGetters({
      invoiceTypes: 'exsbinvoice/list/invoiceTypeOptions',
      documentTypes: 'exsbinvoice/list/documentTypeOptions',
      invoiceStatuses: 'exsbinvoice/list/invoiceStatusOptions',
      paymentWays: 'exsbinvoice/list/paymentWayOptions'
    })
  },
  created () {
    this.fetchInvoiceTypeOptions()
    this.fetchPaymentWayOptions()
    this.fetchInvoiceStatusOptions()
    this.fetchBuyerTagOptions()
    this.fetchAgreementTagOptions()
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.currentPage = 1
        this.$emit('currentPageChange', 1)
        let url = 'e_x_s_b_invoices'
        let params = JSON.parse(JSON.stringify(this.filters))
        if (typeof params.order !== 'undefined') {
          if (params.order === 1) {
            params['order[createdAt]'] = 'desc'
          } else if (params.order === 0) {
            params['order[issueDate]'] = 'desc'
            params['order[numberValue]'] = 'desc'
            params['order[batchNumber]'] = 'desc'
          } else if (params.order === 2) {
            params['order[issueDate]'] = 'desc'
            params['order[batchNumber]'] = 'desc'
            params['order[numberValue]'] = 'desc'
          } else if (params.order === 3) {
            params['order[sellDate]'] = 'desc'
            params['order[batchNumber]'] = 'desc'
            params['order[numberValue]'] = 'desc'
          }
        }
        params.order = undefined
        this.getPage(addParamsToQuery(url, params))
      }
    }
  },
  methods: {
    clearFilters () {
      this.$emit('periodDateChange', '')
      this.$emit('dateTypeChange', 1)
      this.periodDate = ''
      this.dateType = 1
      this.filters = Object.assign(this.filters, this.filterReference)
      this.buyerTagsFilter = []
      this.agreementTagsFilter = []
    },
    getPage (url) {
      this.$emit('getPage', url)
    },
    onDateTypeSelect (type) {
      if (type === 1) {
        this.filters['sellDate[after]'] = ''
        this.filters['sellDate[before]'] = ''
      } else if (type === 2) {
        this.filters['issueDate[after]'] = ''
        this.filters['issueDate[before]'] = ''
      }
      this.$emit('dateTypeChange', type)
    },
    onPeriodSelect (date) {
      if (date) {
        date += '-01'
        if (this.dateType === 1) {
          this.filters['issueDate[after]'] = date
          this.filters['issueDate[before]'] = this.$moment(date).endOf('month').format('YYYY-MM-DD')
          this.filters['sellDate[after]'] = ''
          this.filters['sellDate[before]'] = ''
        } else if (this.dateType === 2) {
          this.filters['sellDate[after]'] = date
          this.filters['sellDate[before]'] = this.$moment(date).endOf('month').format('YYYY-MM-DD')
          this.filters['issueDate[after]'] = ''
          this.filters['issueDate[before]'] = ''
        }
      }
      this.$emit('periodDateChange', date)
    },
    onSelectBuyerTag (items, lastSelectItem) {
      this.buyerTagsFilter = items
      this.filters['idUserData.userDataTags.idTag'] = items.map(item => {
        return item.value
      })
      this.lastSelectItem = lastSelectItem
    },
    onSelectAgreementTag (items, lastSelectItem) {
      this.agreementTagsFilter = items
      this.filters['idAgreement.agreementTags.tag'] = items.map(item => {
        return item.value
      })
      this.lastSelectItem = lastSelectItem
    },
    async fetchBuyerTagOptions () {
      let params = { pagination: false, tagType: 2 }
      const response = await new ApiService('e_x_c_m_tags', params).getResults()
      this.buyerTagOptions = response.items.map(tag => { return { value: tag['@id'], text: tag.tag } })
    },
    async fetchAgreementTagOptions () {
      let params = { pagination: false, tagType: 1 }
      const response = await new ApiService('e_x_c_m_tags', params).getResults()
      this.agreementTagOptions = response.items.map(tag => { return { value: tag['@id'], text: tag.tag } })
    },
    ...mapActions({
      fetchInvoiceTypeOptions: 'exsbinvoice/list/fetchInvoiceTypeOptions',
      fetchPaymentWayOptions: 'exsbinvoice/list/fetchPaymentWayOptions',
      fetchInvoiceStatusOptions: 'exsbinvoice/list/fetchInvoiceStatusOptions'
    })
  },
  directives: {
    debounce
  }
}
</script>

<style scoped>

</style>
